import { Controller } from 'stimulus'

// Group filter on the Help Center's video shelf (help/_videos).
export default class extends Controller {
  static targets = ['filter']

  filter(event) {
    const group = event.currentTarget.dataset.group
    this.filterTargets.forEach(button => button.setAttribute('aria-pressed', String(button === event.currentTarget)))
    this.element.querySelectorAll('[data-video-group]').forEach(card => {
      card.hidden = Boolean(group) && card.dataset.videoGroup !== group
    })
  }
}
